import { rgba } from "polished";
import colors from "../colors";
import { ThemeColors } from "../types";

const dark: ThemeColors = {
  white: colors.white,
  black: colors.black,
  textGrey: colors.grays.gray8,
  primary: colors.white,
  primaryHover: colors.grays.gray8,
  secondary: colors.grays.gray4,
  secondaryHover: colors.grays.gray3,
  accent: colors.reds.red1,
  accentHover: colors.reds.red2,
  success: colors.green.green5,
  successDark: colors.green.green2,
  successMid: colors.green.green3,
  successLight: colors.green.green4,
  error: colors.reds.red3,
  inputLabel: colors.grays.gray12,
  shadow: rgba(colors.blacks.black0, 0.3),
  background: colors.grays.gray1,
  sidebarBackground: colors.grays.gray1,
  logo: colors.grays.gray10,
  border: colors.grays.gray275,
  inputsBackground: colors.grays.gray275,
  highlightLight: colors.yellow.yellow2,
  highlightDark: colors.yellow.yellow1,
  highlightBackground: rgba(colors.black, 0.05),
  inputsBackgroundHover: colors.black,
  cartItemBackground: colors.grays.gray275,
  navItemBackground: colors.grays.gray25,
  icon: colors.grays.gray8,
  iconHover: colors.white,
  iconBackground: rgba(colors.white, 0.04),
  iconBackgroundHover: rgba(colors.white, 0.24),
  itemBackground: colors.grays.gray2,
  itemBackgroundHover: colors.grays.gray285,
  highlight: colors.yellow.yellow2,
};

export default dark;
